//Generated File 
export const First = `First`;
export const Last = `Last`;
export const Next = `Next`;
export const Previous = `Previous`;
